import React from "react"
import { Link, graphql } from "gatsby"
import { css } from "@emotion/react"
import { rhythm } from "../utils/typography"
import Layout from "../components/layout"
import globalStyle from '../styles/global.module.css';
export default function Home({ data }) {
  return (
    <Layout>
      <div style={{ margin: `2rem auto`, maxWidth: `1024px`, padding: `0 1rem` }}>
        <div className="intro">
          <p> Hi I am Vishal Rajput. I am a frontend developer from India <span role="img" aria-label ="india" title='india'>🇮🇳</span>. </p>
          <p> I <span role="img" aria-label="love" title="love">❤️</span> reading and experimenting with web technologies. So I have started this blog to share what I learn with everyone. I hope you will like it. </p>
          <p> You may know more about me <Link to={'/about'}>here</Link></p>
        </div> 
        <div className={globalStyle.blogHead}>
            <h4>Latest articles</h4>
            <Link to="/blog/">Read all articles</Link>
        </div>
        {data.allMarkdownRemark.edges.map(({ node }) => (
          <div key={node.id}>
            
            <h3 css={css`margin-bottom: ${rhythm(1 / 4)};`}> <Link to={node.fields.slug}>{node.frontmatter.title}</Link>{" "}
              <span css={css`color: #bbb;`}> — {node.frontmatter.date} </span>
            </h3>
            <p>{node.excerpt}</p>
            {node.frontmatter.tags.map((tag, index) => (
               <Link key={index} to={`/tags/${tag}`}>
                 <span css={css`color: #bbb;`}> #{tag} </span>
               </Link>
            ))}
          </div>
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(limit: 3) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
            tags
          }
          excerpt
          fields {
            slug
          }
        }
      }
    }
  }
`